import { NavItem } from "../nav-item/nav-item";


export const navItems: NavItem[] = [
  {
    navCap: 'Menú',
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'primary',
    route: '/admin',
  },
  {
    displayName: 'Clientes',
    iconName: 'building-store',
    bgcolor: 'primary',
    route: '/admin/stores',
  },
  {
    displayName: 'Usuarios',
    iconName: 'users',
    bgcolor: 'primary',
    route: '/admin/users',
  },
  {
    displayName: 'Correos',
    iconName: 'mail-fast',
    bgcolor: 'primary',
    children: [
      {
        displayName: 'Campañas',
        iconName: 'send',
        bgcolor: 'primary',
        route: '/admin/mails/campaigns',
      },
      {
        displayName: 'Plantillas',
        iconName: 'template',
        bgcolor: 'primary',
        route: '/admin/mails/templates',
      },
    ],
  },
  {
    displayName: 'Facturación',
    iconName: 'currency-dollar',
    bgcolor: 'primary',
    route: '/admin/billing',
  },
  {
    displayName: 'Beneficios',
    iconName: 'gift',
    bgcolor: 'primary',
    children: [
      {
        displayName: 'Beneficios',
        iconName: 'gift',
        bgcolor: 'primary',
        route: '/admin/beneficios',
      },
      {
        displayName: 'Categorías',
        iconName: 'category',
        bgcolor: 'primary',
        route: '/admin/beneficios/categorias',
      },
    ],
  },
  {
    displayName: 'Giftcards',
    iconName: 'ticket',
    bgcolor: 'primary',
    route: '/admin/giftcards',
  },
  {
    displayName: 'Notificaciones',
    iconName: 'bell-ringing',
    bgcolor: 'primary',
    route: '/admin/push',
  },
  {
    displayName: 'Club',
    iconName: 'users-group',
    bgcolor: 'primary',
    route: '/admin/club',
  },
];
